import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Reusable conversion CTA banner.
 */
export default function CtaBanner({
  title = "Ready to launch and scale?",
  subtitle = "Get a free 30-minute audit of your marketplace accounts. No commitment.",
  primaryLabel = "Get Free Audit",
  primaryTo = "/contact/?type=audit",
  secondaryLabel = "Talk to an Expert",
  secondaryTo = "/contact/?type=expert",
  tape = "For Indian D2C Brands",
}) {
  return (
    <section
      data-testid="cta-banner"
      className="relative border-y-2 border-black bg-[#FFD700] py-16 md:py-24"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-center px-6 text-center md:px-8">
        <div className="tape">{tape}</div>
        <h2 className="display mt-5 text-4xl font-black leading-tight tracking-tight text-black md:text-5xl lg:text-6xl">
          {title}
        </h2>
        <p className="mt-4 max-w-2xl text-base text-black/80 md:text-lg">{subtitle}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link to={primaryTo} className="btn-brutal dark" data-testid="cta-banner-primary">
            {primaryLabel} <ArrowUpRight size={16} />
          </Link>
          <Link to={secondaryTo} className="btn-brutal secondary" data-testid="cta-banner-secondary">
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
